import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const Location = () => {
  const form = Form.useFormInstance();
  const formValues = Form.useWatch(['location'], form);
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <FormLineLayout
      label="Location"
      description="If applicable, it will be highlighted in the activity title"
      disabled={!isEditMode}
    >
      <Form.Item name="location">
        {isEditMode ? (
          <Input />
        ) : (
          <span className="view-data">{formValues || 'ø empty'}</span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
